<div
  class="fixed inset-0  bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300"
  *ngIf="show"
  (click)="close()"
>
  <div
    class="bg-white rounded-lg shadow-lg w-full max-w-2xl relative"
    (click)="$event.stopPropagation()"
  >
    <!-- Botão fechar -->
    <!-- <button
      class="absolute top-2 right-3 text-gray-500 hover:text-gray-800 text-xl"
      (click)="close()"
    >
      ×
    </button> -->

    <!-- Slot de conteúdo -->
    
    <div class=" flex flex-col gap-2">
      <div class="flex items-center justify-between p-3 rounded-lg bg-[#E5E7EB]">
        <div class="flex gap-2">
          <div class="text-center text-sm">
            <p>Pos.</p>
            <p class="text-[#012169] font-semibold">{{ dados?.claNrPosicao }}<span>°</span></p>
          </div>
    
          <div class="text-[#333333] text-sm">
            <p>Participante</p>
            <p class="text-[#012169] font-semibold">{{ dados?.incTxResumo }}</p>
          </div>
        </div>
  
        <fa-icon icon="xmark" (click)="close()" class="h-full text-xl cursor-pointer text-[#787878]" *ngIf="show"></fa-icon>
      </div>
    
      <div class="flex flex-wrap gap-3 p-3 mt-5 mb-5 text-sm text-[#787878]">
        <div class="flex items-center rounded gap-1 p-1 bg-[#ECEDF2]">
          <span class="font-bold">Pontos:</span>
          <span>{{ dados?.claNrPontos }}</span>
        </div>
        <div class="flex items-center rounded gap-1 p-1 bg-[#ECEDF2]">
          <span class="font-bold">Vitórias:</span>
          <span>{{ dados?.claNrVitorias }}</span>
        </div>
        <div class="flex items-center rounded gap-1 p-1 bg-[#ECEDF2]">
          <span class="font-bold">Empates:</span>
          <span>{{ dados?.claNrEmpates }}</span>
        </div>
        <div class="flex items-center rounded gap-1 p-1 bg-[#ECEDF2]">
          <span class="font-bold">Derrotas:</span>
          <span>{{ dados?.claNrDerrotas }}</span>
        </div>
        <div class="flex items-center rounded gap-1 p-1 bg-[#ECEDF2]">
          <span class="font-bold">Qtd. Jogos:</span>
          <span>{{ dados?.claNrVitorias }}</span>
        </div>
        <div class="flex items-center rounded gap-1 p-1 bg-[#ECEDF2]">
          <span class="font-bold">Períodos Perdidos:</span>
          <span>{{ dados?.claNrPeriodosPerdidos }}</span>
        </div>
        <div class="flex items-center rounded gap-1 p-1 bg-[#ECEDF2]">
          <span class="font-bold">Períodos Ganhos:</span>
          <span>{{ dados?.claNrPeriodosGanhos }}</span>
        </div>
        <div class="flex items-center rounded gap-1 p-1 bg-[#ECEDF2]">
          <span class="font-bold">Pontos Marcado:</span>
          <span>{{ dados?.claNrPontosMarcados }}</span>
        </div>
        <div class="flex items-center rounded gap-1 p-1 bg-[#ECEDF2]">
          <span class="font-bold">Pontos Sofrido:</span>
          <span>{{ dados?.claNrPontosSofridos }}</span>
        </div>
        <div class="flex items-center rounded gap-1 col-span-1 p-1 bg-[#ECEDF2] sm:col-span-2">
          <span class="font-bold">Critério de desempate:</span>
          <span>{{ dados?.claTxCriterioDesempate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
